export default __webpack_public_path__ + "static/media/Logowhite.6090ab5e.svg";